<script setup lang="ts">
import { fr } from '@nuxt/ui/locale'
</script>

<template>
  <UApp :toaster="{ position: 'top-right' }" :locale="fr">
    <ImpersonationBanner />
    <NuxtPage />
  </UApp>
</template>
